import React from 'react';
import styled from 'styled-components';

// constants
import { variants, sizes } from './style';

export interface CircleProps {
  size?: keyof typeof sizes;
  flexShrink?: number;
  variant?: keyof typeof variants;
  className?: string;
  active?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const defaultSize = 'sm';

const StyledCircle = styled.div.withConfig({
  shouldForwardProp: prop => !['variant', 'size', 'flexShrink', 'paddingLeft'].includes(prop),
})<CircleProps>`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => sizes[props.size || defaultSize]};
  height: ${props => sizes[props.size || defaultSize]};
  ${props => variants[props.variant || 'action']};
  flex-shrink: ${props => props.flexShrink || 0};
`;

const Circle = (props: CircleProps) => {
  return <StyledCircle {...props} />;
};

export default Circle;
